export const ArrowLeftIcon = ({
  width = 20,
  height = 20,
  color = '#4D4D4D',
  ...rest
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 20 20"
      fill="none"
    >
      <path
        d="M11.666 15L6.66602 10L11.666 5"
        stroke={color}
        strokeWidth="1.4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const ArrowRightIcon = ({
  width = 20,
  height = 20,
  color = '#4D4D4D',
  ...rest
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 20 20"
      fill="none"
    >
      <path
        d="M8.33398 5L13.334 10L8.33398 15"
        stroke={color}
        strokeWidth="1.4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const BreadcrumbsSeparator = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="12"
      height="12"
      viewBox="0 0 12 12"
      fill="none"
    >
      <path
        d="M4 2L7.91965 5.81156C7.94512 5.83629 7.96533 5.86566 7.97912 5.898C7.9929 5.93033 8 5.965 8 6C8 6.035 7.9929 6.06967 7.97912 6.102C7.96533 6.13434 7.94512 6.16371 7.91965 6.18844L4 10"
        stroke="#999999"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
